import { render, staticRenderFns } from "./AdministratorDetails.vue?vue&type=template&id=16b7a4cf&scoped=true&"
import script from "./AdministratorDetails.vue?vue&type=script&lang=js&"
export * from "./AdministratorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b7a4cf",
  null
  
)

export default component.exports